import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

import {mediaQueryBreakpointSM} from "../Utils/Utils.js";

const ACFBlockRecipeList = (domEl) => {

	const swiperEl = domEl.querySelector('.swiper');
	if(!swiperEl) {
		return;
	}

	const options = {
		modules: [Navigation, Pagination, Autoplay,],
		loop: false,
		autoplay: domEl.hasAttribute('data-autoplay'),
		speed: 300,
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: domEl.querySelector('.swiper-button-next'),
			prevEl: domEl.querySelector('.swiper-button-prev'),
		},
		pagination: {
			el: domEl.querySelector('.swiper-pagination'),
			type: 'bullets',
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		breakpoints: {
			[mediaQueryBreakpointSM]: {
				slidesPerView: 3,
			},
		}
	};
	new Swiper(swiperEl, options);
};

export default ACFBlockRecipeList;